module.exports = __webpack_public_path__ + "static/media/logo-kopsurat-ricci.1d4502b4.png";